import ko from 'knockout';

export default class ViewModel {
  constructor(options) {
    this.firstLoad = ko.observable(true);
    this.loaded = ko.observable(false);
    this.inProgress = ko.observable(false);
    this.noData = ko.observable(true);
    this.showNoDataMessage = options.showNoDataMessage;
    this.moreThanLimit = ko.observable(false);
    this.hasChanges = ko.observable(false);
    this.searchResultAriaLabel = ko.observable('');
  }
}
